import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

import {
  breadcrumbContainerClass,
  breadcrumbItemClass,
  breadcrumbSeparatorClass,
  breadcrumbTitleClass,
  breadcrumbTrailClass,
} from "@/contexts/BreadcrumbsUtils";
import { cn } from "@/lib/utils";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export interface BreadcrumbsProps {
  title?: string;
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumbs({ title, items, className }: BreadcrumbsProps) {
  return (
    <div className={cn(breadcrumbContainerClass, className)}>
      {title && (
        <p className={breadcrumbTitleClass}>
          {title}
        </p>
      )}
      <div className={breadcrumbTrailClass}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isLink = Boolean(item.href) && !isLast;

          return (
            <div key={index} className="flex items-center gap-2">
              {index > 0 && (
                <ChevronRight className={breadcrumbSeparatorClass} />
              )}
              {isLink ? (
                <Link
                  to={item.href as string}
                  className={breadcrumbItemClass({ interactive: true })}
                >
                  {item.label}
                </Link>
              ) : (
                <h1
                  aria-current={isLast ? "page" : undefined}
                  className={breadcrumbItemClass({ isActive: isLast })}
                >
                  {item.label}
                </h1>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
